export const QuizResultSkeleton = () => (
  <div className="border-primary flex flex-col-reverse rounded-lg border p-8 sm:flex-row">
    <div className="flex w-full flex-col border-t pr-0 pt-4 sm:w-1/2 sm:border-t-0 sm:pr-4 sm:pt-0">
      <div className="bg-tertiary h-3.5 w-full rounded sm:w-56" />
      <div className="bg-tertiary mt-3 h-5 w-20 rounded" />
      <div className="bg-tertiary mt-5 h-9 w-28 rounded" />
    </div>
    <div className="flex w-full justify-between pb-4 pl-0 sm:w-1/2 sm:pb-0 sm:pl-4">
      <div className="flex w-full flex-col">
        <div className="bg-tertiary h-3.5 w-20 rounded" />
        <div className="bg-tertiary mt-3 h-5 w-14 rounded" />
      </div>
      <div className="flex w-full flex-col">
        <div className="bg-tertiary h-3.5 w-20 rounded" />
        <div className="bg-tertiary mt-3 h-5 w-14 rounded" />
      </div>
    </div>
  </div>
);
